import Router from 'vue-router';
import Vue from 'vue';
Vue.use(Router);
export default new Router({
	routes: [{
			path: '/',
			redirect: '/tileset'
		},
		{
			path: '/report',
			component: () => import( /* webpackChunkName: "home" */ '../view/report.vue'),
			meta: {
				title: '推演报告'
			},
		},

		{
			path: '/tileset',
			component: () => import( /* webpackChunkName: "login" */ '../view/tileset.vue'),
			meta: {
				title: '主页'
			}
		},
		{
			path: '/edit',
			component: () => import( /* webpackChunkName: "home" */ '../view/edit.vue'),
			meta: {
				title: '推演报告'
			},
		},

	]
});
